import { createSlice } from '@reduxjs/toolkit';

const initialState = '';

const cbpInvoiceDetailSlice = createSlice({
  name: 'stop/cbpInvoiceDetail',
  initialState,
  reducers: {
    getCbpInvoiceDetail: (state, action) => action.payload,
    resetCbpInvoiceDetail: () => initialState,
  },
});

export const { getCbpInvoiceDetail, resetCbpInvoiceDetail } =
  cbpInvoiceDetailSlice.actions;
export default cbpInvoiceDetailSlice.reducer;
